import { useCallback, useMemo } from 'react'
import { ProgressOverviewPageConfig } from '../../../../../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { ProcessTreeSelect } from '../../../../ProjectPlanSelect/ProcessTreeSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  FormSection,
  FormLabel,
  PageTitleInput,
} from '../styles'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

type ConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

export const ProgressOverviewConfigForm = ({
  page,
  snapshotUuid,
  onUpdate,
}: ConfigFormProps) => {
  const config = useMemo(
    () => page.config as ProgressOverviewPageConfig,
    [page.config]
  )

  const { handlePageTitleChange } = usePageConfigHandlers(page, onUpdate)

  const handleTargetUuidsChange = useCallback(
    (uuids: string[]) => {
      onUpdate(page.pageNumber, prevEntity => {
        const currentConfig = prevEntity.config as ProgressOverviewPageConfig
        return {
          ...prevEntity,
          config: {
            ...currentConfig,
            targetUuids: uuids,
          },
        }
      })
    },
    [onUpdate, page.pageNumber]
  )

  return (
    <ConfigContainer>
      <SectionContent>
        <FormSection>
          <PageTitleInput
            label="ページタイトル"
            value={page.pageTitle}
            onChange={handlePageTitleChange}
            placeholder="ページのタイトルを入力してください"
            variant="outlined"
            required={true}
          />
        </FormSection>
        <FormSection>
          <FormLabel>対象工程を選択してください</FormLabel>
          <ProcessTreeSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={config.targetUuids || []}
            onChange={handleTargetUuidsChange}
          />
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
